import React from 'react';
import './VideoWithInfo.scss';
import { getIcon } from '../Icons';

interface Info {
  icon: string;
  title: string;
  description: string;
  link: string;
}
interface VideoWithInfoProps {
  video: string;
  info: Info[];
}
export default function VideoWithInfo({ video, info }: VideoWithInfoProps) {
  return (
    <section className="video-with-info">
      <div className="video-with-info__video-container">
        <iframe
          width="100%"
          height="305"
          src={video}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
      <div className="video-with-info__info-container">
        {info.map(({ icon, title, description, link }) => (
          <a key={title} className="video-with-info__info" href={link}>
            <span>{getIcon(icon)}</span>
            <div className="video-with-info__info-text">
              <h4>{title}</h4>
              <p>{description}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
